module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container clearfix"
  }, [_c('person', {
    attrs: {
      "counselor-id": _vm.counselorId,
      "loan-type-arr": _vm.loanTypeArr
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "articles-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('typebar', {
    attrs: {
      "loan-type-arr": _vm.loanTypeArr,
      "selected-index": _vm.selectedIndex
    },
    on: {
      "on-item-click": _vm.onTypeChange
    }
  }), _vm._v(" "), _c('div', {
    ref: "articleList",
    staticClass: "articles-list"
  }, [_c('datagrid', {
    attrs: {
      "articleList": _vm.articleList
    },
    on: {
      "on-item-click": _vm.onItemClick
    }
  })], 1), _vm._v(" "), _c('Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleList.length === 0),
      expression: "articleList.length === 0"
    }],
    attrs: {
      "height": 100,
      "is-no-more": _vm.articleListNoMore
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagebar-box"
  }, [_c('pagination', {
    attrs: {
      "align": 'right',
      "count": _vm.count,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "on-page-click": _vm.onPageClick
    }
  })], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "area-title",
    attrs: {
      "data-v-ccf85fc8": ""
    }
  }, [_c('span', {
    staticClass: "article-title"
  }, [_vm._v("文章列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6fa30204"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultant/consultant-articles.vue
// module id = 613
// module chunks = 1